import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import "../styles/no-sdgs.css";

interface IProps {
  warningText?: React.ReactNode;
}

const NoSdgs: React.FC<IProps> = ({ warningText }) => {
  const defaultWarning = `To identify your sustainability focus we will use a basic materiality process. Don’t worry if you don’t know what this means, we will guide you through an exercise that will take you less than 10 minutes. 
    We understand EVERY event is different so doing this exercise for every event will help you take credible and creative approach to sustainability.  Click the button below to start`;

  return (
    <div className="no-sdgs-card">
      <div className="no-sdgs-content">
        <div className="no-sdgs-icon-wrapper">
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className="no-sdgs-icon"
          />
        </div>

        <div className="no-sdgs-text warning-bg">
          <p>{warningText || defaultWarning}</p>
        </div>
      </div>
    </div>
  );
};

export default NoSdgs;
